
export const theme_ns: ThemeNS = 'demo2025';
